/**
 * Right-hand column of a single BO comment row. Acts as a visibility
 * shell: when `showWriteBackNote` is false, nothing is rendered (but
 * the wrapping `<div>` and outer ref remain so the original-comment
 * column's height computation still has a target).
 *
 * @module busniessOffice/components/singleComment/WriteBackPanel
 */

import React from "react";

interface WriteBackPanelProps {
  id: string;
  showWriteBackNote: boolean;
  containerRef: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
}

const WriteBackPanel = ({
  id,
  showWriteBackNote,
  containerRef,
  children,
}: WriteBackPanelProps) => {
  return (
    <div
      className={`single-comment-writeback h-fit flex-1 ${
        showWriteBackNote ? "rounded-md border border-primaryGray-14" : ""
      }`}
      id={`write-back-note-${id}`}
      ref={containerRef}
    >
      {showWriteBackNote && children}
    </div>
  );
};

export default WriteBackPanel;
